import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { RootState, useAppSelector } from 'src/store';
import { useCompaniesApi } from '../api';
import {
  resetAdminCompanyList as resetList,
  resetError,
  setAdminCompanyList as setList,
  setAdminCompanyListFilter as setFilter,
  setError,
  setLoading,
} from '../slices';

export const useAdminCompaniesService = () => {
  const dispatch = useDispatch();
  const { getState } = useStore<RootState>();
  const {
    loading,
    adminCompanyListFilter: filter,
    adminCompanyList: list,
    error,
  } = useAppSelector((state) => state.companies);

  const api = useCompaniesApi();

  const getCompanies = useCallback(async () => {
    const filter = getState().companies.adminCompanyListFilter;

    try {
      dispatch(resetError());
      dispatch(setLoading({ getAdminCompanyList: true }));

      const response = await api.getAdminCompanies({
        limit: filter.limit,
        offset: filter.offset,

        query: filter.query || undefined,
        sort: filter.sort,
        applicationIds: filter.applicationIds || undefined,
        selfService: filter.selfService,
      });
      dispatch(setList(response.data));

      return response.data;
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ getAdminCompanyList: false }));
    }
  }, []);

  const changeCompaniesFilter = useCallback((filter: Partial<RootState["companies"]["adminCompanyListFilter"]>) => {
    dispatch(setFilter(filter));
  }, []);

  const resetCompanies = useCallback(() => {
    dispatch(resetList());
  }, []);

  return {
    loading,
    filter,
    list,
    error,
    getCompanies,
    changeCompaniesFilter,
    resetCompanies,
  };
};
